import React, {FC, useCallback} from 'react';

import {CardAttributeUpdateAction} from '../../../helpers/models/cardAttributeUpdateHelpers';
import {VisualContactModel} from '../../../models/api/visualContactModel';
import {useContactDetailsContext} from '../contactDetailsContext';
import {AddInformationPopoverContainer} from './addInformationPopoverContainer';

/*
 * Props.
 */

interface ContactInformationAddButtonProps {
  contact?: VisualContactModel;
}

/*
 * Component.
 */

export const ContactInformationAddButton: FC<ContactInformationAddButtonProps> = (props) => {
  const {contact} = props;
  const {
    isReadOnly,
    conversationNamespace,
    createNewCardAsync,
    storedActionsContext: {storedActions, unsavedCard, onUpdateUnsavedCard},
  } = useContactDetailsContext();
  const isCreatingCard = storedActions.length > 0;

  const updateUnsavedCard = useCallback(
    async (action: CardAttributeUpdateAction) => {
      onUpdateUnsavedCard(action);
      // If we do not have a card, create one and store the action we need to perform
      if (!unsavedCard && contact) {
        await createNewCardAsync(
          contact.name || contact.contact.handle,
          contact.contact,
          conversationNamespace,
        );
      }
    },
    [contact, conversationNamespace, createNewCardAsync, onUpdateUnsavedCard, unsavedCard],
  );

  if (isReadOnly) {
    return null;
  }

  return (
    <AddInformationPopoverContainer
      card={unsavedCard}
      onAddInformation={updateUnsavedCard}
      isDisabled={isCreatingCard}
    />
  );
};
